import React from 'react';
import PropTypes from 'prop-types';
import Assets from '../../../../../requests/apa/Asset';
import playerPlaceholder from '../../assets/player-placeholder.jpg';
import './_MatchDetailPlayerCard.scss';

const DEFAULT_STAT_VALUE = 8;

const getSafeStatValue = (stats, key) => {
  if (!stats || stats[key] === undefined || stats[key] === null) return DEFAULT_STAT_VALUE;
  return stats[key];
};

const MatchDetailPlayerCard = ({ player, statKeys }) => {
  const safePlayer = player || {};
  const name = safePlayer.name || 'Nombre de jugador';
  const number = safePlayer.number !== undefined ? safePlayer.number : 34;
  const photo = safePlayer.photo || '';

  return (
    <article className="match-detail-player-card">
      <div className="match-detail-player-card__header">
        <span className="match-detail-player-card__avatar-cell">
          <img
            src={photo || Assets.get('eventodeportivo_placeholder_imagen_jugador_6')}
            alt={name}
            className="match-detail-player-card__avatar"
            onError={function(e) {
              e.target.onerror = null;
              e.target.src = Assets.get('eventodeportivo_placeholder_imagen_jugador_6');
            }}
          />
        </span>
        <span className="match-detail-player-card__name-cell">
          <span className="match-detail-player-card__name">{name}</span>
        </span>
        <span className="match-detail-player-card__number-cell">
          <span className="match-detail-player-card__number"># {number}</span>
        </span>
      </div>

      <table className="match-detail-player-card__stats-table">
        <thead>
          <tr>
            {statKeys.map((key) => (
              <th key={key}>{key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {statKeys.map((key) => (
              <td key={`${safePlayer.id || name}-${key}`}>{getSafeStatValue(safePlayer.stats, key)}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </article>
  );
};

MatchDetailPlayerCard.propTypes = {
  player: PropTypes.object,
  statKeys: PropTypes.array
};

MatchDetailPlayerCard.defaultProps = {
  player: {},
  statKeys: []
};

export default MatchDetailPlayerCard;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailPlayerCard/MatchDetailPlayerCard.jsx